<template>  
    <div class="no-sidebar-narrow-canvas-container" :class="{'mobile-view': relatedData.mobileVersion}">
      <div class="">
        <div class="mb-3 p-0">
          <div class="no-sidebar-narrow-canvas-product-content">           
              <div class="p-0" v-if="data.showSeals">
                <div class="d-flex justify-content-center">
                  <Seal :data="data" :isSizeWindow="relatedData.isSizeWindow" />
                </div>
              </div>            
            <template v-for="(producedFieldData, index) in producedFieldDatas">
            <div
              :key="index"
              v-if="shouldRender(producedFieldData) && (!relatedData.isSizeWindow && producedFieldData.name !== 'guaranteeSeal') && showProductVariants(producedFieldData.name)"
              :data-name="producedFieldData.name"
              :style="{
                height: producedFieldData.name === 'buyButton' && data.floatingButton ? '0 !important' : undefined,
                marginTop: (producedFieldData.name === 'buyButton' && data.floatingButton) || (producedFieldData.name === 'shipping' && !shouldRender(producedFieldData))
                  ? '0 !important'
                  : undefined,
                display: (producedFieldData.name === 'saveThisInformation' && data.saveInfoWithoutEnable) || (producedFieldData.name === 'productDetails' && data.type !== 'variable') || (producedFieldData.name === 'shipping' && !shouldRender(producedFieldData))
                  ? 'none !important'
                  : undefined,
              }"
              class="min-width-narrow-canvas-container mw-100"
            >
              <div
                class="p-0 embed-leftHide"
                v-if="data.showProductImages || data.bullets.length"
              >
                <Left
                  :selectedbumpArray="relatedData.selectedbumpArray"
                  :totalBumpOrderPrice="relatedData.totalBumpOrderPrice"
                  :popup="relatedData.popup"
                  :embed="relatedData.embed"
                  :data="data"
                  :form="relatedData.form"
                  :payload="relatedData.payload"
                  :codPrice="relatedData.codPrice"
                  :priceWithoutWhosale="relatedData.priceWithoutWhosale"
                  :loadingPrice="relatedData.loadingPrice"
                  :isBuyButtonLoading="relatedData.isBuyButtonLoading"
                  :delivery="relatedData.delivery"
                  :price="relatedData.price"
                  :weight="relatedData.weight"
                  :quantity="relatedData.quantity"
                  :cartQuantity="relatedData.cartQuantity"
                  :totalPrice="relatedData.totalPrice"
                  :isSizeWindow="relatedData.mobileVersion"
                  :cartSummary="relatedData.cartSummary"
                  :showCaptcha="relatedData.showCaptcha"
                  :pos="producedFieldData"
                  :posName="producedFieldData.name"
                  :productImages="relatedData.productImages"
                  :variantImageIndex="relatedData.variantImageIndex"
                  :posIndex="producedFieldData.posIndex"
                  @onSave="onSave"
                  :cartTotal="relatedData.cartTotal"
                  :shippingDiscountValue="relatedData.shippingDiscountValue"
                  @updateCartTotal="updateCartTotal"
                  @updateCartSummary="updateCartSummary"
                  @cartOrderSummary="cartOrderSummary"
                  :errors="relatedData.errors"
                  @onValidate="onValidate"
                  :submited="relatedData.submited"
                  @onSubmitted="onSubmitted"
                  :VATPrice="relatedData.VATPrice"
                />
              </div>

              <div class="custom-margin-y p-0">
                <Right
                  :selectedbumpArray="relatedData.selectedbumpArray"
                  :popup="relatedData.popup"
                  :embed="relatedData.embed"
                  :data="data"
                  :form="relatedData.form"
                  :payload="relatedData.payload"
                  :codPrice="relatedData.codPrice"
                  :priceWithoutWhosale="relatedData.priceWithoutWhosale"
                  :loadingPrice="relatedData.loadingPrice"
                  :isBuyButtonLoading="relatedData.isBuyButtonLoading"
                  :delivery="relatedData.delivery"
                  :discountLists="relatedData.discountLists"
                  :price="relatedData.price"
                  :weight="relatedData.weight"
                  :noProductOptionQty="relatedData.quantity"
                  :totalPrice="relatedData.totalPrice"
                  :isSizeWindow="relatedData.mobileVersion"
                  :cartSummary="relatedData.cartSummary"
                  :cartQuantity="relatedData.cartQuantity"
                  :cartTotal="relatedData.cartTotal"
                  :showCaptcha="relatedData.showCaptcha"
                  :pos="producedFieldData"
                  :posName="producedFieldData.name"
                  :productImages="relatedData.productImages"
                  :totalQuantity="relatedData.totalQuantity"
                  :variantImageIndex="relatedData.variantImageIndex"
                  :courierOptionDataFinal="relatedData.courierOptionDataFinal"
                  :shippingDiscountValue="relatedData.shippingDiscountValue"
                  :filterAttributes="relatedData.filterAttributes"
                  :isVariableItemSelected="relatedData.isVariableItemSelected"
                  :posIndex="producedFieldData.posIndex"
                  :is-mobile="isMobile"
                  @updateCartTotal="updateCartTotal"
                  @onSave="onSave"
                  @addToCart="addToCart"
                  @cartOrderSummary="cartOrderSummary"
                  @updateCartSummary="updateCartSummary"
                  @showMobile="showMobile"
                  @updateCheckout="updateCheckout"
                  @updateCartQuantity="updateCartQuantity"
                  :errors="relatedData.errors"
                  @onValidate="onValidate"
                  :submited="relatedData.submited"
                  @onSubmitted="onSubmitted"
                  :user="relatedData.user"
                  @applyDiscount="applyDiscount"
                  @clearDiscount="clearDiscount"
                  @updateDiscountLists="updateDiscountLists"
                  :VATPrice="relatedData.VATPrice"
                  @onAddressChange="onAddressChange"
                  :allEstimatePublic="relatedData.allEstimatePublic"
                />
              </div>
            </div>
            </template>
          </div>
        </div>
      </div>
    </div> 
</template>

<script>
import Seal from "@/components/Form/seal";
import Left from "@/components/Form/left";
import Right from "@/components/Form/right";

// import { getSizedImageUrl } from "~/helpers/imagekitHelper";

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    relatedData: {
      type: Object,
      required: true,
    },
    producedFieldDatas: {
      type: Array,
      default: () => ["singledummy"],
    },
    isMobile: {
      type: Boolean,
    },
  },
  components: {
    Seal,
    Right,
    Left,
  },
  data() {
    return {
      // You can add data properties here
    };
  },
  methods: {
    updateCartTotal(value) {
      this.$emit("updateCartTotal", value);
    },
    onSave() {
      this.$emit("onSave");
    },
    addToCart() {
      this.$emit("addToCart");
    },
    cartOrderSummary() {
      this.$emit("cartOrderSummary");
    },
    updateCartSummary(index) {
      this.$emit("updateCartSummary", index);
    },
    showMobile(orderSummary) {
      this.$emit("showMobile", orderSummary);
    },
    updateCheckout() {
      this.$emit("updateCheckout");
    },
    updateCartQuantity(value) {
      this.$emit("updateCartQuantity", value);
    },
    onValidate(value) {
      this.$emit("onValidate", value);
    },
    onSubmitted(value) {
      this.$emit("onSubmitted", value);
    },
    applyDiscount(discountTitle) {
      this.$emit("applyDiscount", discountTitle);
    },
    updateDiscountLists(discounts,replace){
      this.$emit('updateDiscountLists',discounts,replace)
    },
    clearDiscount(code) {
      this.$emit("clearDiscount", code);
    },
    shouldRender(component) {
      if (!this.isMobile) return true;

      if (['productDetails', 'requestedFields', 'buyButton'].includes(component.name)) return true;
      if (['guaranteeSeal'].includes(component.name)) return false;
      
      if (component.name === 'shipping') {
        return this.data.addShipping &&
          (this.relatedData.payload.payment === 'COD' ? this.data.shippingCOD.shippingType === 'automated' : this.data.shippingType === 'automated') &&
          this.relatedData.payload.address &&
          this.relatedData.courierOptionDataFinal &&
          this.relatedData.courierOptionDataFinal.length > 0 &&
          (this.relatedData.courierOptionDataFinal.length > 1 ||
            (this.relatedData.courierOptionDataFinal.length == 1 && !this.data.shippingHideView))
      }

      if (component.name === 'bump') {
        return this.data.bumpArray.length > 0;
      }
      if (component.name === 'productDetails') {
        return this.data.attributes.map(attr => attr.name).filter(Boolean).length > 0;
      }
      if (component.name === 'productImage') {
        return this.relatedData.productImages.length > 0;
      }
      if (component.name === 'componentVideo') {
        return this.relatedData.componentVideo;
      }
      if (component.name === 'otherContent') {
        return this.data.otherContent;
      }
      if (component.name === 'payment') {
        return this.data.paymentType && this.data.paymentType.filter((p) => p.active).length > 0;
      }

      // based on toggle v-model show hide component, search div with class right-adjust-positions
      return this.data && this.data[component.buttonVar]
    },
    showProductVariants(sectionName) {
      if (sectionName === 'productDetails' && this.data.hasProgressiveVariants) {
        const fields = this.data.requestedFields.filter(field => field.active);
        const totalFields = fields.length;
        const totalFieldsFilled = fields.filter(field => field.value !== '').length;
        return totalFieldsFilled === totalFields;
      }

      return true;
    },
    onAddressChange(val, from = "autofill") {
      const keyMap = {
        province: 'PROVINCE_NAME',
        city: 'CITY_NAME',
        district: 'DISTRICT_NAME',
        subdistrict: 'SUBDISTRICT_NAME',
        autofill: 'ENTER_CITY_NAME',
      };

      const key = keyMap[from];
      if (!key) return;

      const targetField = this.data.requestedFields.find(field => field.key === key);
      if (targetField) {
        targetField.value = val.customerFULL_AUTOFILL;
      }
    }
  },
  emits: [
    "updateCartTotal",
    "onSave",
    "addToCart",
    "cartOrderSummary",
    "updateCartSummary",
    "showMobile",
    "updateCheckout",
    "updateCartQuantity",
    "onValidate",
    "onSubmitted",
    "applyDiscount",
    "clearDiscount",
  ],
};
</script>

<style lang="scss">
.no-sidebar-narrow-canvas-container {

  .checkout-content--left__feature.checkout-content--left__main__product-image {
    display: flex;
    justify-content: center;
    background-color: unset !important;

    .left__main__product-image__container--swiper {
      max-width: 100%;

      .swiper-pagination-bullet {
        margin: 0 5px;
      }
    }
  }

  .checkout-content--left__container {
    .embed-checkout-left__container.checkout-container.d-block.classic {
      .checkout-content--left__main.checkout-content--left__main--container {
        @media screen and (min-width: 561px) {
          padding: 20px !important;
        }
      }
    }
  }

  &.mobile-view {
    .checkout-content--left__container {
    .embed-checkout-left__container.checkout-container.d-block.classic {
      .checkout-content--left__main.checkout-content--left__main--container {
        padding: 0px !important;
      }
    }
  }
  }

  .embed-sealHide {
    @media screen and (min-width: 767px) {
      margin-bottom: 20px;
    }
  }

  .custom-margin-y {
    @media screen and (min-width: 768px) {
      margin-top: 16px;
      margin-bottom: 16px;
    }
  }
}
</style>

<style lang="scss" scoped>
$spacer: 16px;

.d-flex {
  display: flex !important;
}

.justify-content-center {
  justify-content: center !important;
}

.align-items-center {
  align-items: center !important;
}

.p-0 {
  padding: 0px !important;
}

.p-2 {
  padding: ($spacer * 0.5) !important;
}

.mt-2 {
  margin-top: ($spacer * 0.5) !important;
}

.mb-2 {
  margin-bottom: ($spacer * 0.5) !important;
}

.mb-3 {
  margin-bottom: ($spacer * 1) !important;
}

.my-1 {
  margin-top: ($spacer * 0.25) !important;
  margin-bottom: ($spacer * 0.25) !important;
}

.my-2 {
  margin-top: ($spacer * 0.5) !important;
  margin-bottom: ($spacer * 0.5) !important;
}

.my-3 {
  margin-top: ($spacer * 1) !important;
  margin-bottom: ($spacer * 1) !important;
}

.ml-1 {
  margin-left: ($spacer * 0.25) !important;
}

.mw-100 {
  max-width: 100% !important;
}
</style>
